<template>
  <div class="inventory-no-items">
    <div class="inventory-no-items__grid">
      <div
        v-for="i in 30"
        :key="`grid-item-${i}`"
        class="grid-item"
      >
        <component :is="itemPlaceholders[i % itemPlaceholders.length]" />
      </div>

      <div class="inventory-no-items__content">
        <slot name="full">
          <div class="content__inner">
            <svg class="content__inner-svg">
              <use xlink:href="/icons/sprite.svg#i-empty-steam-box" />
            </svg>

            <slot>
              <div class="content__inner-body">
                <p class="title">
                  {{ t('no_items_inventory') }}
                </p>
                <p class="subtitle">
                  {{ t('user_skins_not_added') }}
                </p>
                <button
                  class="btn btn-primary btn-violet"
                  type="button"
                  @click="emit('updateInventory')"
                >
                  <i class="i-refresh" />
                  {{ t('update_inventory') }}
                </button>
              </div>
            </slot>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Ak47 from '~/components/Icons/ItemPlaceholder/Ak47.vue';
import Awp from '~/components/Icons/ItemPlaceholder/Awp.vue';
import Gloves from '~/components/Icons/ItemPlaceholder/Gloves.vue';
import Key from '~/components/Icons/ItemPlaceholder/Key.vue';
import Knife from '~/components/Icons/ItemPlaceholder/Knife.vue';
import Pistol from '~/components/Icons/ItemPlaceholder/Pistol.vue';
import TalonKnife from '~/components/Icons/ItemPlaceholder/TalonKnife.vue';
import Usp from '~/components/Icons/ItemPlaceholder/Usp.vue';

const emit = defineEmits(['updateInventory']);
const itemPlaceholders = [Ak47, Usp, Key, Gloves, Knife, Awp, Pistol, TalonKnife];
const { t } = useI18n();
</script>

<style lang="scss" scoped>
.inventory-no-items {
  width: 100%;
  position: relative;

  &__grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;

    .grid-item {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 16px;
      border-radius: 12px;
      background: var(--surfaces-low-container);
      aspect-ratio: 1 / 1.2;

      svg {
        width: 100%;
        object-fit: contain;
        color: var(--surfaces-container);
      }
    }
  }

  &__content {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .content__inner {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      &-svg {
        max-width: 160px;
        object-fit: contain;
        object-position: center;
        margin-bottom: 32px;
      }

      &-body {
        max-width: 350px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          color: var(--surfaces-on-surface);
          font-size: 18px;
          font-weight: 600;
          line-height: normal;
          margin-bottom: 8px;
        }

        .subtitle {
          color: var(--surfaces-on-surface-variable);
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 28px; /* 175% */
          margin-bottom: 20px;
        }

        .btn {
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 18px; /* 128.571% */
          gap: 6px;

          i {
            font-weight: 400;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    &__grid {
      display: block;
      background: var(--surfaces-low-container);
      padding: 32px 20px;

      .grid-item {
        display: none;
      }
    }
    &__content {
      position: relative;

      .content__inner {
        &-svg {
          max-width: 140px;
        }

        &-body {
          .title {
            font-size: 14px;
          }

          .subtitle {
            font-size: 14px;
            line-height: 26px; /* 175% */
            margin-bottom: 16px;
          }
        }
      }
    }
  }
}
</style>
